export default __webpack_public_path__ + "static/media/calm-waters.a9236af4.jpg";